export default __webpack_public_path__ + "static/media/crystal.ac5f3d56.png";